export const BRAIN_EVENT_SCHEDULE = {
  date: '20 Iunie 2026',
  location: 'Sala Palatului, București',
  checkIn: '09:00',
  officialStart: '10:30',
  endApprox: '20:00',
  eventAccess: '10:30 - 20:00',
  leadMessage: 'Accesul participanților începe la ora 09:00.',
  timeline: [
    { time: '09:00 – 10:30', activity: 'Check-in și networking' },
    { time: '10:30', activity: 'Deschidere oficială' },
    { time: '10:30 – 13:00', activity: 'Program conferință' },
    { time: '13:00 – 14:00', activity: 'Prânz și networking' },
    { time: '14:00 – 16:30', activity: 'Program conferință' },
    { time: '16:30 – 17:00', activity: 'Pauză și networking' },
    { time: '17:00 – 20:00', activity: 'Program conferință' },
    { time: '20:00', activity: 'Se termină evenimentul' },
    { time: '20:30 – 00:00', activity: 'Cină festivă Ultra VIP' },
  ],
};
